import React, { createContext, useContext, useState, ReactNode } from 'react';

interface PageHeaderContextType {
  customTitle: string | null | undefined;
  setCustomTitle: (title: string | null | undefined) => void;
}

const PageHeaderContext = createContext<PageHeaderContextType | undefined>(undefined);

export const PageHeaderProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [customTitle, setCustomTitle] = useState<string | null | undefined>(undefined);

  return (
    <PageHeaderContext.Provider value={{ customTitle, setCustomTitle }}>
      {children}
    </PageHeaderContext.Provider>
  );
};

export const usePageHeader = () => {
  const context = useContext(PageHeaderContext);
  if (!context) {
    throw new Error('usePageHeader must be used within PageHeaderProvider');
  }
  return context;
};

